<div class="header">
  <div>
    <h2>User Checks System</h2>
    <p>
      Streamline user tracking and control all relevant settings efficiently for
      accurate and organized management
    </p>
  </div>
</div>

<div class="rp-body">
  <ng-container *ngIf="loading || showSkeleton">
    <div class="rp-outer" *ngFor="let _ of [1,2,3,4]">
      <div class="heading-outer">
        <div class="skeleton-row" style="height: 25px; width: 30%; margin: 0;"></div>
        <div class="skeleton-row" style="height: 25px; width: 50px; margin: 0; border-radius: 15px;"></div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!loading && !showSkeleton">
    <div class="rp-outer">
      <div class="heading-outer">
        <h4>
          Device Check
          <div class="tooltip-wrapper">
            <img src="assets/images/warningIcon.svg" alt="icon" class="mr-2" />
            <span class="tooltip-text">It Work on Attendance it Check Radius and Device id from User.</span>
          </div>
        </h4>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="deviceCheck" #toggleDevice (change)="onDeviceClick($event, toggleDevice)" />
          <span class="slider"></span>
        </label>
      </div>
    </div>

    <div class="rp-outer">
      <div class="heading-outer">
        <h4>
          Leave Check
          <div class="tooltip-wrapper">
            <img src="assets/images/warningIcon.svg" alt="icon" class="mr-2" />
            <span class="tooltip-text">It set Leave Annual and Monthly.</span>
          </div>
        </h4>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="leaveCheck" #toggleLeave (change)="onLeaveClick($event, toggleLeave)" />
          <span class="slider"></span>
        </label>
      </div>
    </div>

    <div class="rp-outer">
      <div class="heading-outer">
        <h4>
          2 Factor Authentication
          <div class="tooltip-wrapper">
            <img src="assets/images/warningIcon.svg" alt="icon" class="mr-2" />
            <span class="tooltip-text">It set Google Authentication on login Screen.</span>
          </div>
        </h4>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="authKey" #toggleAuth (change)="onAuthClick($event, toggleAuth)" />
          <span class="slider"></span>
        </label>
      </div>
    </div>

    <div class="rp-outer">
      <div class="heading-outer">
        <h4>
          Leave Set Date
          <div class="tooltip-wrapper">
            <img src="assets/images/warningIcon.svg" alt="icon" class="mr-2" />
            <span class="tooltip-text">Enter Date When You want to Reset Your Leaves.</span>
          </div>
        </h4> 
        <button (click)="toggleDateModal()">
          {{ getFormattedDate() }}
          <img src="assets/images/editIcon2.svg" alt="" />
        </button>
      </div>
    </div>
  </ng-container>
</div>

<app-add-popup *ngIf="showDateModal" title="Edit Leave Set Date"
  subtitle="Enter the date below when you want to reset your leaves" iconPath="assets/images/editPopup.png"
  (close)="toggleDateModal()">
  <div class="popup-form-content">
    <div class="input-group">
      <label>Date*</label>
      <div class="date-input-wrapper">
        <input type="date" [(ngModel)]="leaveSetDate" class="pill-input" />
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn-cancel" (click)="toggleDateModal()">
        Cancel
      </button>
      <button type="button" class="btn-save" (click)="onSaveDate()">
        <img src="assets/images/savePopup.svg" alt="" /> Save
      </button>
    </div>
  </div>
</app-add-popup>

<!-- Device Check confirmation modal -->
<div class="modal fade" id="confirmModalDevice" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content custom-modal">
      <div class="modal-header text-white" style="border-bottom: none;">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cancelDeviceToggle()">×</button>
      </div>
      <div class="modal-body text-center">
        <img src="assets/images/trackerQuestion.png" class="imageConfirmModal" alt="img loading..." />
        <p class="modal-text mt-3">Are you sure you want to <span class="textColorQuestionMOdal">{{ intendedDeviceStatus ? 'Enable' : 'Disable' }}</span> Device Check?</p>
        <div class="buttonTrackers gap-3 mt-3 mb-3">
          <button type="button" class="subBtnModalTrackerOff custom-btn mr-3" data-dismiss="modal" (click)="cancelDeviceToggle()">Cancel</button>
          <button type="button" class="subBtnModalTrackerOn custom-btn" data-dismiss="modal" (click)="confirmDeviceToggle()">Confirm</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Leave Check confirmation modal -->
<div class="modal fade" id="confirmModalLeave" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content custom-modal">
      <div class="modal-header text-white" style="border-bottom: none;">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cancelLeaveToggle()">×</button>
      </div>
      <div class="modal-body text-center">
        <img src="assets/images/trackerQuestion.png" class="imageConfirmModal" alt="img loading..." />
        <p class="modal-text mt-3">Are you sure you want to <span class="textColorQuestionMOdal">{{ intendedLeaveStatus ? 'Enable' : 'Disable' }}</span> Leave Check?</p>
        <div class="buttonTrackers gap-3 mt-3 mb-3">
          <button type="button" class="subBtnModalTrackerOff custom-btn mr-3" data-dismiss="modal" (click)="cancelLeaveToggle()">Cancel</button>
          <button type="button" class="subBtnModalTrackerOn custom-btn" data-dismiss="modal" (click)="confirmLeaveToggle()">Confirm</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 2FA confirmation modal (component-level) -->
<div class="modal fade" id="confirmModalAuth" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content custom-modal">
      <div class="modal-header text-white" style="border-bottom: none;">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cancelAuthToggle()">×</button>
      </div>
      <div class="modal-body text-center">
        <img src="assets/images/trackerQuestion.png" class="imageConfirmModal" alt="img loading..." />
        <p class="modal-text mt-3">Are you sure you want to <span class="textColorQuestionMOdal">{{ intendedAuthStatus ? 'Enable' : 'Disable' }}</span> 2FA?</p>
        <div class="buttonTrackers gap-3 mt-3 mb-3">
          <button type="button" class="subBtnModalTrackerOff custom-btn mr-3" data-dismiss="modal" (click)="cancelAuthToggle()">Cancel</button>
          <button type="button" class="subBtnModalTrackerOn custom-btn" data-dismiss="modal" (click)="confirmAuthToggle()">Confirm</button>
        </div>
      </div>
    </div>
  </div>
</div>